import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { token, me } = useAuth();
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace />;
  // Enquanto `me` não carrega, deixa passar — o próprio ChangePassword lida
  // com o estado de carregamento sem quebrar. Se veio senha temporária, o
  // usuário só sai da tela de troca depois de definir uma senha própria;
  // impede que ele acesse dashboards com credencial provisória.
  if (me?.mustChangePassword && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }
  return <>{children}</>;
}
